import { useFirebase } from "containers/FirebaseContext";
import { collection, doc, doc as firestoreDoc, getDocs, query, updateDoc, where } from "firebase/firestore";
import * as Sentry from '@sentry/react';

export const useCollectionLoteria = () => {
    const { firestore } = useFirebase();
    const updateLoteriaResult = async (submission_id, result) => {
        try {
        if (!submission_id || submission_id === undefined) {
            console.error("Invalid submission_id: Cannot update Loteria result with undefined submission_id");
            Sentry.captureException("110 Error during Firebase updateLoteriaResult: submission_id is undefined");
            return;
        }
            const collectionRef = collection(firestore, "bingo_submission");
            const q = query(collectionRef, where("submission_id", "==", submission_id));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach(async (doc) => {
                const data = doc.data();
                if (data) {
                    const docRef = firestoreDoc(collectionRef, doc.id);
                    await updateDoc(docRef, {
                        teacher_response: result || ""
                    });
                }
            })
        } catch (error) {
            console.log(error, "error update Bingo");
            Sentry.captureException(`110 Error during Firebase updateLoteriaResult ${error}.`);
        }
    }

    const updateTeacherWinner = async (id, result, user_id) => {
        if (!id) {
            console.error("Invalid document ID");
            return;
        }
        const docRef = doc(firestore, "bingo", id);
        if (!user_id) {
            console.error("Invalid user_id: user_id is undefined or missing");
            Sentry.captureException("111 Error during Firebase updateTeacherWinner: user_id is undefined");
            return;
        }
        try {
            if (result) {
                await updateDoc(docRef, {
                    winner_declared: result === 'accept',
                    winner_id: user_id, 
                });
            }
        } catch (error) {
            console.error("Error updating document: ", error);
            Sentry.captureException(`111 Error during Firebase updateTeacherWinner ${error}.`);
        }
    };

    const updateRealTimeClick = async (updatedItems, bingoResponseId, userId) => {
        if (!bingoResponseId || !userId) return {}
        try {
            const submissionQuery = query(
                collection(firestore, "bingo_submission"),
                where("bingo_id", "==", bingoResponseId),
                where("user_id", "==", userId)
            );
    
            const submissionSnapshot = await getDocs(submissionQuery);
    
            if (!submissionSnapshot.empty) {
                const submissionDocRef = doc(firestore, "bingo_submission", submissionSnapshot.docs[0].id);
    
                await updateDoc(submissionDocRef, {
                    answer_text: JSON.stringify(updatedItems)
                });
            }
        } catch (error) {
            console.error("Error updating Firestore:", error);
            Sentry.captureException(`112 Error during Firebase updateRealTimeClick ${error}.`);
        }
    };

    const updateStudentEnter = async (bingoResponseId, userId) => {
        if (!bingoResponseId || !userId) return {}
        try {
            const submissionQuery = query(
                collection(firestore, "bingo_submission"),
                where("bingo_id", "==", bingoResponseId),
                where("user_id", "==", userId)
            );
    
            const submissionSnapshot = await getDocs(submissionQuery);
    
            if (!submissionSnapshot.empty) {
                const submissionDocRef = doc(firestore, "bingo_submission", submissionSnapshot.docs[0].id);
                await updateDoc(submissionDocRef, {
                    user_grade: true
                });
            }
        } catch (error) {
            console.error("Error updating Firestore:", error);
            Sentry.captureException(`113 Error during Firebase updateStudentEnter ${error}.`);
        }
    };

    const createDraftBingo = async (draftId, updatedData) => {
        if (!draftId) {
            console.error("Invalid draftId");
            return;
        }
        try {
            const docRef = doc(firestore, import.meta.env.VITE_APP_STAGE?.trim() === 'prod' ? 'draft_activity_prod' : 'draft_activity', draftId);
            await updateDoc(docRef, updatedData);
        } catch (error) {
            console.error("Error updating draft activity document:", error);
            Sentry.captureException(`114 Error during Firebase createDraftBingo ${error}.`);
        }
    };

    return { updateLoteriaResult, updateTeacherWinner, updateRealTimeClick, updateStudentEnter, createDraftBingo }
}